import * as React from 'react'
import TextFlowObject from '../../model/TextFlowObject'
import { MMOOptions } from './mmo-interactor'
import {TextEditor} from '../text_editor/editor'
import { applyRatio, rotationToDeg } from './helpers'
import { MachineContext } from '../fsm/useMachine'
import { MARK_EDITOR_ACTIVE, SET_CURRENT_OBJECT } from '../fsm/types'

export interface TextViewOptions {
    mmo: TextFlowObject
    editing: [{[key: string]: boolean}, React.Dispatch<React.SetStateAction<{[key: string]: boolean}>>]
}

export const TextView: React.FC<TextViewOptions & MMOOptions> = (props) => {
    const [current, send] = React.useContext(MachineContext)
    const {mmo, forwardedRef, size, setShowTransformer, editing} = props
    const scaledObjects = applyRatio({
        left: mmo.frame.x,
        top: mmo.frame.y,
        width: mmo.frame.width,
        height: mmo.frame.height,
    }, size.ratio)
    const [allowEdit, setAllowEdit] = editing
    const [markForDestruction, setMark] = React.useState(false)

    const singleClick = (e: React.MouseEvent<HTMLElement | SVGSVGElement>) => {
        if (!allowEdit[mmo.id]) {
            props.onClick(e)
        }
    }

    const doubleClick = () => {
        if (!allowEdit[mmo.id]) {
            setAllowEdit(allows => ({
                ...allows,
                [mmo.id]: true
            }))
            setShowTransformer(false)
            send([{ type: SET_CURRENT_OBJECT, id: mmo.id }, { type: MARK_EDITOR_ACTIVE }])
        }
    }

    React.useEffect(() => {
        setMark(true)
    }, [current.context.index])

    React.useEffect(() => {
        if (markForDestruction) {
            setMark(false)
        }
    }, [markForDestruction])

    if (markForDestruction) {
        return null;
    }
    
    return (
        <div
            //@ts-ignore
            ref={props.forwardedRef}
            style={{
                ...scaledObjects,
                position: "absolute",                
                transform: `rotate(${rotationToDeg(mmo.rotation)}deg)`,
            }}
            id={mmo.id.replace(/-/g, "")}
            className="mmo"
            {...props}
            onClick={singleClick}            
            onDoubleClick={doubleClick}
        >
        <TextEditor 
        {...props}
        editOptions={[allowEdit,setAllowEdit]}
        />
        </div>
    )
}